import type { TyreStatus } from '@chukua/common';
import { Button } from 'antd';
import { Pencil } from 'lucide-react';
import { availableTyreMoves } from '../policies/tyre-available-moves.policy';
import { TYRE_MOVE_TITLES, type TyreMoveKind } from '../policies/tyre-move.policy';

interface TyreActionsProps {
  status: TyreStatus;
  onMove: (kind: TyreMoveKind) => void;
  onEdit: () => void;
}

/** The buttons on a tyre's own page: the moves its status allows, then Edit. */
export function TyreActions({ status, onMove, onEdit }: TyreActionsProps) {
  return (
    <>
      {availableTyreMoves(status).map((kind) => (
        <Button key={kind} danger={kind === 'scrap'} onClick={() => onMove(kind)}>
          {TYRE_MOVE_TITLES[kind]}
        </Button>
      ))}
      <Button icon={<Pencil className="size-4" />} onClick={onEdit}>
        Edit
      </Button>
    </>
  );
}
